import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_EXPORT_DATA = Symbol('export-data');

export const EXPORT_DATA_GET_ROUTE_NAME = Symbol('export-data.get');

export const EXPORT_DATA_TYPES_URL = 'admin/csv_reports/types';
export const EXPORT_DATA_TYPES_QUERY_KEY = 'export-data.types';

export const EXPORT_DATA_GENERATE_URL = 'admin/csv_reports';
export const EXPORT_DATA_GENERATE_MUTATION_KEY = 'export-data.generate';

export const EXPORT_DATA_PERMISSIONS = {
  CREATE: new Permission(PermissionsList.admin.CSVREPORTS_CREATE),
};
